
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 81 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M58.551 2.517A2.515 2.515 0 0161.064 0a2.515 2.515 0 012.513 2.517 2.515 2.515 0 01-2.513 2.518 2.515 2.515 0 01-2.513-2.518zm-36.186 7.612a7.172 7.172 0 011.834 4.791v8.728h-3.853v-8.837c-.008-1.737-1.44-3.155-3.183-3.155-.1 0-.209.008-.318.017-1.558.159-2.865 1.636-2.865 3.23v8.745h-3.853v-8.812c-.008-1.745-1.432-3.172-3.175-3.172-.1 0-.209.009-.318.017-1.55.16-2.865 1.636-2.865 3.239v8.728H0v-8.837c0-3.86 3.141-6.998 6.994-6.998 1.927 0 3.761.805 5.085 2.207a6.992 6.992 0 015.109-2.207 6.868 6.868 0 015.177 2.316zm25.883 13.535h-3.853V.378h3.853zm7.371 0h-3.853V.378h3.853zm7.372-.008h-3.853V8.215h3.853zM81 17.312H69.281a4.33 4.33 0 004.172 3.172 4.297 4.297 0 003.711-2.098l.159-.26 3.183 1.569-.184.311a8.105 8.105 0 01-6.936 3.96h-.009c-2.161 0-4.188-.856-5.721-2.408a8.019 8.019 0 01-2.337-5.765 8.057 8.057 0 012.354-5.614 7.982 7.982 0 015.596-2.366h.1c2.036 0 3.945.814 5.394 2.282A7.733 7.733 0 0181 15.541zm-11.66-3.189h7.765c-.553-1.645-2.128-2.803-3.887-2.803a4.115 4.115 0 00-3.878 2.803zm-27.022 1.779c0 4.448-3.619 8.073-8.058 8.073-4.44 0-8.059-3.625-8.059-8.073 0-4.447 3.611-8.073 8.059-8.073 4.447 0 8.058 3.626 8.058 8.073zm-3.82.008a4.247 4.247 0 00-4.238-4.246 4.248 4.248 0 000 8.493 4.247 4.247 0 004.238-4.247z"}})])
          )
        }
      }
    